import { render, staticRenderFns } from "./ksCustomerChurn.vue?vue&type=template&id=6b6df619&scoped=true&"
import script from "./ksCustomerChurn.vue?vue&type=script&lang=js&"
export * from "./ksCustomerChurn.vue?vue&type=script&lang=js&"
import style0 from "./ksCustomerChurn.vue?vue&type=style&index=0&id=6b6df619&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6df619",
  null
  
)

export default component.exports